<template>
    <v-container>
        <p class="font-weight-black display-4">Gallery</p>
        <p class="font-weight-regular display-1">See how Diffuse handle all kinds of music :-P</p>
        <v-divider class="divider-extended"></v-divider>
        <masonry
                :cols="{default: 5, 1900: 4, 1400: 3, 900: 2, 500: 1}"
                :gutter="0">
            <div v-for="(item, index) in items" :key="index">
                <v-card class="ma-2">
                    <v-img v-bind:src="imageBaseUrl + item.imagePath"></v-img>
                    <v-card-title v-if="item.title">{{item.title}}</v-card-title>
                    <v-card-subtitle v-if="item.subtitle">{{item.subtitle}}</v-card-subtitle>
                </v-card>
            </div>
        </masonry>
    </v-container>
</template>

<script>
    export default {
        name: "Gallery",
        created: function()
        {
            this.imageBaseUrl = window.location.origin;
        },
        data: function () {
            return {
                imageBaseUrl: "",
                items: [
                    {
                        title: "Home Screen",
                        subtitle: "Playing Luv (Sic) Pt.3 from Nujabes",
                        imagePath: "/images/gallery/1.jpg"
                    },
                    {
                        title: "App Settings",
                        subtitle: "In Dark Theme",
                        imagePath: "/images/gallery/2.jpg"
                    },
                    {
                        title: "App Settings",
                        subtitle: "In Light Theme",
                        imagePath: "/images/gallery/5.jpg"
                    },
                    {
                        title: "Work with Spotify",
                        imagePath: "/images/gallery/3.jpg"
                    },
                    {
                        title: "Instagram Story Poster",
                        subtitle: "Generated with Diffuse on Samsung Galaxy S10e, was playing Luv (Sic) Pt.3 from Nujabes",
                        imagePath: "/images/gallery/4.jpg"
                    },
                    {
                        title: "Instagram Story Poster",
                        subtitle: "Generated with Diffuse on Redmi K20 Pro, was playing Forgotten from Marcus",
                        imagePath: "/images/gallery/6.jpg"
                    },
                    {
                        title: "Lock Screen",
                        subtitle: "On Samsung One UI",
                        imagePath: "/images/gallery/10.jpg"
                    },
                    {
                        title: "Work with SoundCloud",
                        imagePath: "/images/gallery/11.jpg"
                    },
                    {
                        title: "Playing La Vie En Rose",
                        imagePath: "/images/gallery/12.jpg"
                    },
                    {
                        title: "Playing Love on the Weekend",
                        subtitle: "From John Mayer",
                        imagePath: "/images/gallery/7.jpg"
                    },
                    {
                        title: "Playing Loved Ones",
                        subtitle: "From Armando Young",
                        imagePath: "/images/gallery/8.jpg"
                    },
                    {
                        title: "Playing Konichiwa",
                        subtitle: "From Donny Benet",
                        imagePath: "/images/gallery/9.jpg"
                    },
                ]
            }
        }
    }
</script>

<style scoped>
    .divider-extended
    {
        margin-top: 1rem;
        margin-bottom: 1rem;
    }
</style>